const ParallaxImageTextRight = {
  getSettings: componentSettings => ({
    ...componentSettings,
    parallax: true,
    modifier: 'image-children-right'
  })
};

export default ParallaxImageTextRight;
